define('TescoMobile_CheckoutCareHub/js/view/account-modal-login-prompt-payg',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'mage/url', 'mage/translate'], function (Component, $, ko, modal, urlBuilder, $t) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(true),
    messages: ko.observableArray(),
    form: null,
    setModalElement: function (element) {
      var options = {
          modalClass: 'login-prompt',
          innerScroll: true,
          type: 'popup',
          title: $t('Are you looking to migrate your Tesco Mobile pay-as-you-go number?'),
          clickableOverlay: false,
          opened: function (a, b) {
            this._updateContent(element);
          }.bind(this),
          closed: function () {
            $('body').trigger('prompt-customer-modal-closed');
          }.bind(this)
        },
        self = this;
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      $('body').on('carehub-login-prompt-payg', function (e, data) {
        self.form = data;
        window.dataProductModalId = $(data).find('[name="item"]').val();
        $(element).modal('openModal');
        $('body').trigger('dl-modal-show-new-or-existing');
      });
      $('body').on('customer-login-new', function () {
        $(element).modal('closeModal');
        $('body').trigger('dl-modal-click-new');
      });
      $('body').on('customer-login-payg-migration', function (e, data) {
        $(element).modal('closeModal');
        self.triggerQuoteAsMigration($(element));
        $('body').trigger('dl-modal-click-existing');
      });
      $('body').on('close-all-modals-keep-loader', function (e, elem) {
        $(element).modal('closeModal');
      });
    },
    triggerQuoteAsMigration: function (el) {
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/setcustomerisnew'),
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function () {
          el.modal('closeModal');
          $('body').trigger('existing-customer-login-paym');
        }
      });
    },
    isNewCustomer: function () {
      $.ajax({
        url: urlBuilder.build('checkout/cart/setcustomerisnew'),
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function () {
          $('body').trigger('customer-login-new');
        }
      });
    },
    isMigration: function () {
      $('body').trigger('customer-login-payg-migration', this.form);
    },
    _updateContent: function (element) {
      this.isLoading(false);
    }
  });
});

